import { render, staticRenderFns } from "@/clickbuy/purchase/views/filling-in-form/companion-partial/companion-partial.pug?vue&type=template&id=3a864847&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a864847",
  null
  
)

export default component.exports